import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { GlassCard } from '../components/GlassCard';
import { useUserStore } from '../store/userStore';
import { createSubscription } from '../lib/api';

const PLANS = [
  {
    key: 'monthly',
    name: 'Auralis Thrive',
    price: '£55',
    cadence: 'per month',
    color: '#7C3AED',
    popular: true,
    features: ['Full precision insights unlocked', 'Ongoing monitoring & check-ins', 'Quarterly biomarker reviews', 'Priority clinician messaging'],
  },
  {
    key: 'one_time',
    name: 'Complete Assessment',
    price: '£650',
    cadence: 'one-time',
    color: '#EC4899',
    features: ['Full health consultation', 'Comprehensive risk assessment', 'Personalised treatment plan', '3-month follow-up'],
  },
];

export default function PremiumUpgrade() {
  const navigate = useNavigate();
  const { user, checkPremiumStatus } = useUserStore();
  const [busy, setBusy] = useState(null);

  const upgrade = async (plan) => {
    setBusy(plan);
    try {
      await createSubscription(user.id, plan);
      await checkPremiumStatus();
      toast.success('Welcome to Premium');
      navigate('/assessment/results');
    } catch (e) {
      toast.error('Upgrade could not be completed');
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="min-h-screen aura-space relative">
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 pt-8 pb-16">
        <button onClick={() => navigate(-1)} className="grid place-items-center w-9 h-9 rounded-full glass-dark text-white mb-6"><i className="fa-solid fa-arrow-left" /></button>
        <div className="text-center mb-8">
          <div className="inline-grid place-items-center w-16 h-16 rounded-2xl mb-4" style={{ background: 'linear-gradient(135deg,#E879F9,#7C3AED)' }}>
            <i className="fa-solid fa-crown text-white text-2xl" />
          </div>
          <h1 className="font-display text-3xl sm:text-4xl text-white mb-2">Auralis Premium</h1>
          <p className="text-white/60">Unlock the precision insights that reveal what’s really driving how you feel.</p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          {PLANS.map((p) => (
            <div key={p.key} className="glass-dark rounded-3xl p-6 relative">
              {p.popular && <span className="absolute -top-2.5 left-6 text-[10px] font-bold uppercase tracking-wider text-white rounded-full px-3 py-1" style={{ background: p.color }}>Recommended</span>}
              <div className="font-display text-xl text-white">{p.name}</div>
              <div className="flex items-baseline gap-1 my-3">
                <span className="font-display text-4xl text-white">{p.price}</span>
                <span className="text-white/50 text-sm">{p.cadence}</span>
              </div>
              <ul className="space-y-2 mb-5">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-white/80"><i className="fa-solid fa-check mt-0.5" style={{ color: p.color }} /> {f}</li>
                ))}
              </ul>
              <button
                data-testid={`subscribe-${p.key}`}
                onClick={() => upgrade(p.key)}
                disabled={busy === p.key}
                className="w-full aura-btn-gradient text-white font-semibold rounded-2xl py-3.5 flex items-center justify-center gap-2 disabled:opacity-70"
              >
                {busy === p.key ? <i className="fa-solid fa-circle-notch fa-spin" /> : <>Choose {p.name.split(' ')[1] || 'plan'}</>}
              </button>
            </div>
          ))}
        </div>
        <p className="text-center text-white/40 text-xs mt-6">Payments are simulated for this testing phase.</p>
      </div>
    </div>
  );
}
